/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Announcement,
  AnnouncementChannelEnum,
  AnnouncementInput,
  Announcements,
  AnnouncementsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Announcement
 */
export const createAnnouncement = (
    announcementInput: MaybeRefOrGetter<AnnouncementInput>,
 signal?: AbortSignal
) => {
      announcementInput = toValue(announcementInput);

      return axiosClient<Announcement>(
      {url: `/announcements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: announcementInput, signal
    },
      );
    }




export const getCreateAnnouncementMutationKey = () => ['createAnnouncement'] as const;

export const getCreateAnnouncementMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,CreateAnnouncementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,CreateAnnouncementMutationVariables, TContext> => {

const mutationKey = getCreateAnnouncementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAnnouncement>>, CreateAnnouncementMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAnnouncement(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof createAnnouncement>>>
    export type CreateAnnouncementMutationBody = AnnouncementInput
    export type CreateAnnouncementMutationError = ErrorType<ValidationError | StandardError>
    export type CreateAnnouncementMutationVariables = {data: AnnouncementInput}

    /**
 * @summary Create Announcement
 */
export const useCreateAnnouncement = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAnnouncement>>, TError,CreateAnnouncementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAnnouncement>>,
        TError,
        CreateAnnouncementMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAnnouncementMutationOptions(options), queryClient);
    }
    /**
 * @summary Announcements list
 */
export const announcements = (
    params?: MaybeRefOrGetter<AnnouncementsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Announcements>(
      {url: `/announcements`, method: 'GET',
        params, signal
    },
      );
    }




export const getAnnouncementsQueryKey = (params?: MaybeRefOrGetter<AnnouncementsParams>,) => {
    return [
    'announcements', ...(params ? [params] : [])
    ] as const;
    }


export const getAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof announcements>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<AnnouncementsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAnnouncementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof announcements>>> = ({ signal }) => announcements(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
}

export type AnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof announcements>>>
export type AnnouncementsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Announcements list
 */

export function useAnnouncements<TData = Awaited<ReturnType<typeof announcements>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<AnnouncementsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnnouncementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Announcement Detail
 */
export const announcement = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}`, method: 'GET', signal
    },
      );
    }




export const getAnnouncementQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'announcements',id
    ] as const;
    }


export const getAnnouncementQueryOptions = <TData = Awaited<ReturnType<typeof announcement>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof announcement>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getAnnouncementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof announcement>>> = ({ signal }) => announcement(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof announcement>>, TError, TData>
}

export type AnnouncementQueryResult = NonNullable<Awaited<ReturnType<typeof announcement>>>
export type AnnouncementQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Announcement Detail
 */

export function useAnnouncement<TData = Awaited<ReturnType<typeof announcement>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof announcement>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAnnouncementQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Announcement
 */
export const updateAnnouncement = (
    id: MaybeRefOrGetter<string>,
    announcementInput: MaybeRefOrGetter<AnnouncementInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
announcementInput = toValue(announcementInput);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: announcementInput, signal
    },
      );
    }




export const getUpdateAnnouncementMutationKey = () => ['updateAnnouncement'] as const;

export const getUpdateAnnouncementMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnnouncement>>, TError,UpdateAnnouncementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAnnouncement>>, TError,UpdateAnnouncementMutationVariables, TContext> => {

const mutationKey = getUpdateAnnouncementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAnnouncement>>, UpdateAnnouncementMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAnnouncement(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof updateAnnouncement>>>
    export type UpdateAnnouncementMutationBody = AnnouncementInput
    export type UpdateAnnouncementMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateAnnouncementMutationVariables = {id: string;data: AnnouncementInput}

    /**
 * @summary Update Announcement
 */
export const useUpdateAnnouncement = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAnnouncement>>, TError,UpdateAnnouncementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAnnouncement>>,
        TError,
        UpdateAnnouncementMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAnnouncementMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Announcement
 */
export const destroyAnnouncement = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyAnnouncementMutationKey = () => ['destroyAnnouncement'] as const;

export const getDestroyAnnouncementMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAnnouncement>>, TError,DestroyAnnouncementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyAnnouncement>>, TError,DestroyAnnouncementMutationVariables, TContext> => {

const mutationKey = getDestroyAnnouncementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyAnnouncement>>, DestroyAnnouncementMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyAnnouncement(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof destroyAnnouncement>>>

    export type DestroyAnnouncementMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyAnnouncementMutationVariables = {id: string}

    /**
 * @summary Destroy Announcement
 */
export const useDestroyAnnouncement = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyAnnouncement>>, TError,DestroyAnnouncementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyAnnouncement>>,
        TError,
        DestroyAnnouncementMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyAnnouncementMutationOptions(options), queryClient);
    }
    /**
 * @summary Retry Announcement Delivery
 */
export const retryAnnouncementDelivery = (
    id: MaybeRefOrGetter<string>,
    channel: MaybeRefOrGetter<AnnouncementChannelEnum>,
 signal?: AbortSignal
) => {
      id = toValue(id);
channel = toValue(channel);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}/deliveries/${channel}/retry`, method: 'PUT', signal
    },
      );
    }




export const getRetryAnnouncementDeliveryMutationKey = () => ['retryAnnouncementDelivery'] as const;

export const getRetryAnnouncementDeliveryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnnouncementDelivery>>, TError,RetryAnnouncementDeliveryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof retryAnnouncementDelivery>>, TError,RetryAnnouncementDeliveryMutationVariables, TContext> => {

const mutationKey = getRetryAnnouncementDeliveryMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryAnnouncementDelivery>>, RetryAnnouncementDeliveryMutationVariables> = (props) => {
          const {id,channel} = props ?? {};

          return  retryAnnouncementDelivery(id,channel,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryAnnouncementDeliveryMutationResult = NonNullable<Awaited<ReturnType<typeof retryAnnouncementDelivery>>>

    export type RetryAnnouncementDeliveryMutationError = ErrorType<ValidationError | StandardError>
    export type RetryAnnouncementDeliveryMutationVariables = {id: string;channel: AnnouncementChannelEnum}

    /**
 * @summary Retry Announcement Delivery
 */
export const useRetryAnnouncementDelivery = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryAnnouncementDelivery>>, TError,RetryAnnouncementDeliveryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof retryAnnouncementDelivery>>,
        TError,
        RetryAnnouncementDeliveryMutationVariables,
        TContext
      > => {
      return useMutation(getRetryAnnouncementDeliveryMutationOptions(options), queryClient);
    }
    /**
 * @summary Publish Announcement
 */
export const publishAnnouncement = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}/publish`, method: 'PUT', signal
    },
      );
    }




export const getPublishAnnouncementMutationKey = () => ['publishAnnouncement'] as const;

export const getPublishAnnouncementMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,PublishAnnouncementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,PublishAnnouncementMutationVariables, TContext> => {

const mutationKey = getPublishAnnouncementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishAnnouncement>>, PublishAnnouncementMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  publishAnnouncement(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishAnnouncementMutationResult = NonNullable<Awaited<ReturnType<typeof publishAnnouncement>>>

    export type PublishAnnouncementMutationError = ErrorType<ValidationError | StandardError>
    export type PublishAnnouncementMutationVariables = {id: string}

    /**
 * @summary Publish Announcement
 */
export const usePublishAnnouncement = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishAnnouncement>>, TError,PublishAnnouncementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof publishAnnouncement>>,
        TError,
        PublishAnnouncementMutationVariables,
        TContext
      > => {
      return useMutation(getPublishAnnouncementMutationOptions(options), queryClient);
    }
    /**
 * @summary Refresh Announcement Engagement
 */
export const refreshAnnouncementEngagement = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}/refresh-engagement`, method: 'PUT', signal
    },
      );
    }




export const getRefreshAnnouncementEngagementMutationKey = () => ['refreshAnnouncementEngagement'] as const;

export const getRefreshAnnouncementEngagementMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAnnouncementEngagement>>, TError,RefreshAnnouncementEngagementMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof refreshAnnouncementEngagement>>, TError,RefreshAnnouncementEngagementMutationVariables, TContext> => {

const mutationKey = getRefreshAnnouncementEngagementMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAnnouncementEngagement>>, RefreshAnnouncementEngagementMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  refreshAnnouncementEngagement(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RefreshAnnouncementEngagementMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAnnouncementEngagement>>>

    export type RefreshAnnouncementEngagementMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type RefreshAnnouncementEngagementMutationVariables = {id: string}

    /**
 * @summary Refresh Announcement Engagement
 */
export const useRefreshAnnouncementEngagement = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAnnouncementEngagement>>, TError,RefreshAnnouncementEngagementMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof refreshAnnouncementEngagement>>,
        TError,
        RefreshAnnouncementEngagementMutationVariables,
        TContext
      > => {
      return useMutation(getRefreshAnnouncementEngagementMutationOptions(options), queryClient);
    }
    /**
 * @summary Send Announcement Test
 */
export const sendAnnouncementTest = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Announcement>(
      {url: `/announcements/${id}/send-test`, method: 'PUT', signal
    },
      );
    }




export const getSendAnnouncementTestMutationKey = () => ['sendAnnouncementTest'] as const;

export const getSendAnnouncementTestMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnnouncementTest>>, TError,SendAnnouncementTestMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sendAnnouncementTest>>, TError,SendAnnouncementTestMutationVariables, TContext> => {

const mutationKey = getSendAnnouncementTestMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendAnnouncementTest>>, SendAnnouncementTestMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  sendAnnouncementTest(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SendAnnouncementTestMutationResult = NonNullable<Awaited<ReturnType<typeof sendAnnouncementTest>>>

    export type SendAnnouncementTestMutationError = ErrorType<ValidationError | StandardError>
    export type SendAnnouncementTestMutationVariables = {id: string}

    /**
 * @summary Send Announcement Test
 */
export const useSendAnnouncementTest = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendAnnouncementTest>>, TError,SendAnnouncementTestMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sendAnnouncementTest>>,
        TError,
        SendAnnouncementTestMutationVariables,
        TContext
      > => {
      return useMutation(getSendAnnouncementTestMutationOptions(options), queryClient);
    }
